import Backend from 'backend';
import {customElement, bindable, bindingMode, observable} from 'aurelia-framework';
import {inject} from 'aurelia-framework';
import {download} from "../../util/download-file";
import {IdentityProvider} from "devtag-aurelia-auth-plugin";

@customElement('document-renderings-table-component')
@inject(Backend, Element, IdentityProvider)
export class DocumentRenderingsTableComponent {
  backend;
  element;
  identityProvider;

  @bindable
  documentRenderings;

  constructor(backend, element, identityProvider) {
    this.backend = backend;
    this.element = element;
    this.identityProvider = identityProvider;
  }

  download(documentRendering) {
    return this.backend.DocumentRenderingFileQueryHandler_handle({documentRenderingId: documentRendering.documentRenderingId})
      .then(result => download(result.fileBase64, result.filename))
  }
}
